// extracted by mini-css-extract-plugin
export default {"disconnectedContainer":"disconnected_disconnectedContainer__r-4Ua","loader":"disconnected_loader__DayhR"};